<template>
  <ul class="c-switch">
    <li
      v-for="(item, index) in items"
      :key="index"
      :class="{ 'is-current': current === index }"
    >
      <button @click="$emit('click', index)">{{ item }}</button>
    </li>
  </ul>
</template>

<script>
import { i18n } from '../plugins/i18n'

export default {
  name: 'SwitchDate',
  props: {
    current: String,
    items: {
      type: Object,
      default: () => {
        return {
          day: i18n.t('labels.date.day'),
          week: i18n.t('labels.date.week'),
          month: i18n.t('labels.date.month'),
        }
      },
    }
  },
  emits: ['click']
}
</script>
